export default "__VITE_ASSET__BRN1tpt9__"